export default __webpack_public_path__ + "static/media/homeImage.a7e4da1c.png";